/**
 * MODULE: _shared/frontend-shell/src/features/crm/utils/crmShellSearchMatch.ts
 * PURPOSE: Client-side match for CRM shell `filters.search` against title, owner, notes, etc.
 * DEPENDENCIES: None
 * PUBLIC_API: rowMatchesShellSearch
 * SIDE_EFFECTS: None
 * AGENT_SAFETY: SAFE
 */

/** True when `search` is empty, or any haystack contains the trimmed query (case-insensitive). */
export function rowMatchesShellSearch(search: string, ...haystacks: (string | undefined | null)[]): boolean {
  const q = search.trim().toLowerCase();
  if (!q) return true;
  return haystacks.some((h) => (h ?? '').toLowerCase().includes(q));
}
